var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3272_4450",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3272_4450",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACM0lEQVR4nO3cMW/TQByG8fdSRmhFN9qmMwvKBmLrVAY+Bmo+A6gzCxJkpULq12ABCbEgJIZKXWClDWwgVMbaf4auVXxO3Htj+vzW2L3Ij+7ixNVJAAAAAABcJ6nkYBuH02HU5xOFdqV0q+TYzeJMSu/SYOXZjyeb30qNWizAxuF0GFV1JGm91Jhz+jXQYDTd2zotMdigxCCSFPX5RMt/8SVpPRSvSg1WLMDFstMPEfGo1FjlAizdmj9D0mqpoQoGwGUIYEYAs+zb0Psf/zyOiAMpbV7lG+q/dBoR4y87a29zjs6eARHpNRc/R2ylpIPco1mCzFrMgBhLqci3w547Ua1x7sGtf4q48+Z7tD3nOvm5t93qmrIEmRHAjABmBDAjgBkBzAhgdqPrP/j30+eZr998+OC/Pr8tZoAZAcwIYEYAMwKYEcCMAGY8D+gYzwN6hgBmBDAjgBkBzAhgRgAzngd0fH5bzAAzApgRwIwAZgQwI4AZAcx4HtAxngf0DAHMCGBGADMCmBHAjABmefes+8dDVWkiaVdSf/b98ThTxHtF/VQvRo17zzUH2D8eqk5Hil5sN7ZMfmslRnp+72TWQc1LUJUmXPy53FaVXjYdlPMZ0Ju93pZQ495zOQFY8+fXuPccd0FmBDAjgFnn/xekrx9mv353Z7HzF7Xo+E3nt8QMMCOAGQHMCGBGADMCmBHArPvvAR3fJxdX+P0zA8wIYEYAMwKYEcCMAGYEAAAAAAAABf0D9aV6IUZQBfIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.7a6efb315ac09c2ddbd18bb3267b5ef2.svg";
export { ForwardRef as ReactComponent };